import React from 'react'

const Blog = () => {
  return (
    <div>
      <h1>blog</h1>
    </div>
  )
}

export default Blog
